import { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import CustomDialog from "../CustomComponents/CustomDialog/CustomDialog.jsx";
import {
  freePlanSwitchCopy,
  paidPlanSwitchCopy,
  switchToFreeConfirmCopy,
  UPGRADE_CONFIRM,
} from "../../util/planSwitchCopy";

const PlanSwitchPanel = ({
  isFreePlan,
  feeLabel,
  availableOn,
  periodEnd,
  pendingSwitch,
  canSwitchToFree,
  onConfirmUpgrade,
  onConfirmSwitchToFree,
  isBusy = false,
  canAct = true,
}) => {
  const copy = isFreePlan
    ? freePlanSwitchCopy(feeLabel)
    : paidPlanSwitchCopy({ availableOn, periodEnd, pendingSwitch, canSwitchToFree });
  const [confirmKind, setConfirmKind] = useState("");

  const confirmBody = confirmKind === "upgrade"
    ? UPGRADE_CONFIRM
    : switchToFreeConfirmCopy(periodEnd);

  const closeConfirm = () => setConfirmKind("");

  const handleConfirm = async () => {
    const kind = confirmKind;
    closeConfirm();
    if (kind === "upgrade") {
      await onConfirmUpgrade?.();
      return;
    }
    if (kind === "downgrade") {
      await onConfirmSwitchToFree?.();
    }
  };

  return (
    <section className="setup-guide plan-switch-panel" data-testid="plan-switch-panel">
      <p className="setup-guide-kicker">Your plan</p>
      <h2 className="setup-guide-title">{copy.title}</h2>
      <p className="setup-guide-lead">{copy.body}</p>
      {copy.pending && <p className="setup-guide-lead" data-testid="plan-switch-pending">{copy.pending}</p>}
      {copy.paidThrough && <p className="setup-guide-hint" data-testid="plan-switch-paid-through">{copy.paidThrough}</p>}
      {copy.button && canAct && (
        <div className="setup-guide-actions">
          {copy.disabled || isBusy ? (
            <Tooltip title={copy.tooltip}>
              <span>
                <Button
                  variant="outlined"
                  disabled
                  data-testid="plan-switch-btn"
                >
                  {copy.button}
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button
              variant="contained"
              data-testid="plan-switch-btn"
              onClick={() => setConfirmKind(isFreePlan ? "upgrade" : "downgrade")}
            >
              {copy.button}
            </Button>
          )}
        </div>
      )}
      <CustomDialog
        isOpen={Boolean(confirmKind)}
        onClose={closeConfirm}
        onCancel={closeConfirm}
        onSubmit={handleConfirm}
        title={confirmKind === "upgrade" ? "Upgrade to Paid" : "Switch to Free"}
        submitBtnName="Confirm"
        cancelBtnName="Close"
        disableSubmitBtn={isBusy}
      >
        <p data-testid="plan-switch-confirm">{confirmBody}</p>
      </CustomDialog>
    </section>
  );
};

export default PlanSwitchPanel;
